/**
 * Maps common emoji characters to their accessible descriptions
 * for screen readers
 */
const emojiDescriptionMap: Record<string, string> = {
  '👍': 'thumbs up',
  '👎': 'thumbs down',
  '👏': 'clapping hands',
  '❤️': 'red heart',
  '😀': 'grinning face',
  '😂': 'face with tears of joy',
  '😊': 'smiling face with smiling eyes',
  '😍': 'smiling face with heart-eyes',
  '🤔': 'thinking face',
  '😢': 'crying face',
  '😮': 'face with open mouth',
  '🎉': 'party popper',
  '🔥': 'fire',
  '⭐': 'star',
  '✅': 'check mark',
  '❌': 'cross mark',
  '💯': 'hundred points',
  '🙏': 'folded hands',
  '🎯': 'direct hit',
  '💪': 'flexed biceps',
};

/**
 * Gets the accessible description for an emoji character
 * Falls back to "emoji" if no mapping is found
 */
export const getEmojiDescription = (emoji: string): string => {
  return emojiDescriptionMap[emoji] || 'emoji';
};
